var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pure-text",style:({
    'fontSize': ((_vm.config.fontSize) + "px"),
    'fontWeight': _vm.config.weight,
    'color': _vm.config.pureColor,
    'justifyContent': _vm.config.textAlign,
    'background': _vm.config.background
  })},[_c('span',{class:{ ellipse: _vm.config.isEllipse }},[_vm._v(_vm._s(_vm.config.value))]),(_vm.config.titleContentInfo&&_vm.config.titleContentInfo.length>0)?_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.config.titleContentInfo,"placement":"top-start"}},[_c('i',{staticClass:"el-icon-info"})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }